import script from "./carouselPage.vue?vue&type=script&setup=true&lang=js"
export * from "./carouselPage.vue?vue&type=script&setup=true&lang=js"

import "./carouselPage.vue?vue&type=style&index=0&id=3d5d9dfc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5d9dfc"]])

export default __exports__